import { Component, computed, input } from '@angular/core';
import { FieldState } from '@angular/forms/signals';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-errors',
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (shouldShowError()) {
      @for (error of control().errors(); track error.kind) {
        <small class="text-sm block text-danger mt-1">
          {{ error.message | translate }}
        </small>
      }
    }
  `,
})
export class FormErrors {
  readonly control = input.required<FieldState<unknown>>();

  protected readonly shouldShowError = computed(() => {
    const field = this.control();
    const hasServerError = field.errors().some((e) => e.kind === 'serverError');
    return hasServerError || (!field.valid() && field.touched());
  });
}
